<template>
  <!-- 推荐 -->
  <div class="goods">
    <el-dialog
      :visible="isShowRecommend"
      :close-on-click-modal="false"
      :before-close="exit"
      :title="$t('recommend.推荐列表')"
      ref="dialog"
      class="dialog-dark dialog-center dialog-include-table"
      width="770px"
      @open="onOpen"
      @close="onClose"
    >
      <el-table :data="goodsList" class="table-dark" height="405px">
        <el-table-column :label="$t('recommend.缩略图')" width="200">
          <div class="goods-logo" slot-scope="scope">
            <img :src="scope.row.imgUrl" class="show-goods-logo" />
            <p class="goods-goodsOrder" v-show="scope.row.goodsOrder">
              {{ scope.row.goodsOrder }}
            </p>
          </div>
        </el-table-column>
        <el-table-column
          :label="$t('recommend.推荐主题')"
          prop="title"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column width="140">
          <template slot="header">
            <span>{{ $t("goods.上架状态") }}</span>
            <el-tooltip
              :content="$t('recommend.上架后，观众将在推荐列表中可见')"
              class="item"
              effect="dark"
              placement="top"
            >
              <img class="tip-icon" :src="require('@/svg/tip.svg')" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-switch
              :value="scope.row.shelves"
              class="switch-mini"
              style="width: 28px"
              active-color="#3986EE"
              inactive-color="#5B617E"
              @change="changeshelvesStatus($event,scope.row,scope.$index)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column width="140">
          <template slot="header">
            <span>{{ $t("goods.操作") }}</span>
            <el-tooltip
              :content="$t('recommend.推送后，观众将在推荐列表中可见')"
              class="item"
              effect="dark"
              placement="top"
            >
              <img class="tip-icon" :src="require('@/svg/tip.svg')" />
            </el-tooltip>
          </template>
          <template slot-scope="scope">
            <el-link
              v-show="scope.row.pushStatus == 1"
              :underline="false"
              class="link-text-mini"
              type="primary"
              @click="handelGoods(scope.row)"
              >{{ $t("goods.推送") }}</el-link
            >
            <el-link
              v-show="scope.row.pushStatus == 2"
              :underline="false"
              type="danger"
              class="link-text-mini"
              style="color: #ff595b"
              @click="handelGoods(scope.row)"
              >{{ $t("goods.取消推送") }}</el-link
            >
          </template>
        </el-table-column>
        <template slot="empty">
          <div v-if="loading" class="skelo">
            <div v-for="item in 4" :key="item" class="itemList">
              <div v-for="i in 5" :key="i"></div>
            </div>
          </div>
          <Blank
            v-else
            :src="shangpinImg"
            :text="$t('recommend.暂无推荐')"
            :width="160"
            :height="150"
          />
        </template>
      </el-table>
      <el-pagination
        v-if="total > 0"
        :current-page="pageNum"
        :page-size="pageSize"
        :total="total"
        :pager-count="5"
        class="pagination-dark"
        layout="prev,pager,next"
        background
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </el-dialog>
  </div>
</template>

<script>
import {
  getGoodslist,
  onshelfGoods,
  pushGoods,
} from "@/api/liveRequest/recommend";
import {
  Dialog,
  Link,
  Pagination,
  Switch,
  Table,
  TableColumn,
  Tooltip,
} from "element-ui";
import { mapGetters } from "vuex";
import { getParameter } from "@/utils/global";
import Blank from "@/components/blank";
import shangpinImg from "@/assets/images/blank/shangpin.png";
import { pushRoomMessageFunc } from "@/utils/socketMessageDispose";
export default {
  name: "Recommend",
  components: {
    [Tooltip.name]: Tooltip,
    [Dialog.name]: Dialog,
    [Pagination.name]: Pagination,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Link.name]: Link,
    [Switch.name]: Switch,
    Blank,
  },
  data() {
    return {
      shangpinImg,
      // 是否加载中
      loading: false,
      // 每页显示数量
      pageSize: 4,
      // 当前页码
      pageNum: 0,
      // 商品总数
      total: 0,
      //商品列表
      goodsList: [],
      // 当前推送商品id
      pushId: undefined,
      // 直播间id
      liveId: getParameter("liveId"),
      skelo: [
        { type: "image", style: { width: "70px", height: "70px" } },
        { type: "text", style: { width: "150px", height: "30px" } },
        { type: "text", style: { width: "150px", height: "30px" } },
        { type: "text", style: { width: "150px", height: "30px" } },
        { type: "text", style: { width: "150px", height: "30px" } },
      ],
    };
  },
  computed: {
    ...mapGetters(["isShowRecommend", "userInfo", "liveRoomStatus"]),
    cid() {
      return this.userInfo?.cid;
    },
  },
  created() {
    pushRoomMessageFunc(({ cmd, requestData }) => {
      switch (cmd) {
        case 7107:
          this.message_7107(requestData);
          break;
      }
    });
  },
  methods: {
    message_7107(body) {
      if (body.event === "recommendManager") {
        this.message_7107_goods(body);
      }
    },
    // 处理商品消息
    message_7107_goods({ type }) {
      switch (type) {
        case "sync_live_recommend":
        case "delete_live_recommend":
        case "push_live_recommend":
        case "cancel_push_live_recommend":
        case "onpublish_recommend":
        case "offpublish_live_recommend": {
          console.log("type............",type);
          this.getInit();
          break;
        }
      }
    },
    onOpen() {
      this.getList();
    },
    onClose() {
      this.$store.commit("SET_SHOW_RECOMMEND", false);
    },
    getInit() {
      this.getList();
    },
    getGoods(goodIdList) {
      return this.goodsList.filter((v) => goodIdList.includes(v.recommendId));
    },
    getList() {
      console.log("get list");
      let params = {
        size: this.pageSize,
        page: this.pageNum,
        liveId: this.liveId,
      };
      this.loading = true;
      getGoodslist(params)
        .then((res) => {
          if (res.status == 0) {
            this.goodsList = res.data.list;
            this.goodsList.forEach((item) => {
              item.shelves = item.shelvesStatus == 2 ? true : false;
            });
            this.total = res.data.total;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getList();
    },
    /**
     * 上架取消上架
     */
    async changeshelvesStatus(val,info,index) {
      if (this.liveRoomStatus !== 2) {
        return this.$message.warning(this.$t("common.请先开启直播"));
      }
      console.log(val, "...........val");
      console.log(index, "..........index");
      let paramsInfo = {
        liveId: this.liveId,
        recommendId: info.recommendId,
        shelvesStatus: info.shelvesStatus,
      };
      let handelRes = await onshelfGoods(paramsInfo);
      if (handelRes.status == 0) {
        info.shelvesStatus = info.shelvesStatus == 1 ? 2 : 1;
        info.shelves = !val;
        //this.$set(this.goodsList,index,info);
        console.log(this.goodsList, "goodsList");
      } else {
        this.$message.error(`${handelRes.message}`);
      }
    },
    // 推送or取消推送商品
    async handelGoods(info) {
      if (this.liveRoomStatus !== 2) {
        return this.$message.warning(this.$t("common.请先开启直播"));
      }
      const { status, message } = await pushGoods({
        cid: this.cid,
        liveId: this.liveId,
        recommendId: info.recommendId,
        pushStatus: info.pushStatus,
      });
      if (status == 0) {
        info.pushStatus = info.pushStatus == 1 ? 2 : 1;
        console.log(this.goodsList, "this.goodsList handelGoods");
      }
      if (status != 0) {
        this.$message.error(`${message}`);
      }
    },
    exit(cb) {
      cb();
    },
  },
};
</script>

<style scoped lang="scss">
.goods-null {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.blankList {
  padding: 0 20px;
}
.itemList {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 30px;
  padding-right: 20px;
}
.itemList div {
  background-color: #f3f3f3;
  border-radius: 4px;
  height: 30px;
}
.itemList div:nth-child(1) {
  width: 60px;
  height: 60px;
}
.itemList div:nth-child(2) {
  width: 240px;
}
.itemList div:nth-child(3) {
  width: 90px;
}
.itemList div:nth-child(4) {
  width: 30px;
}
.itemList div:nth-child(5) {
  width: 64px;
}
.itemList:nth-child(1) {
  margin-top: unset;
}
.pagination-dark {
  margin-top: 15px;
  margin-right: 30px;
  display: flex;
  justify-content: flex-end;
}
.goods-logo {
  position: relative;
  height: 60px;
  width: 120px;
  text-overflow: initial;
  border: 1px solid #eaeef6;
  text-align: center;
}
.show-goods-logo {
  height: 60px;
  width: 120px;
  object-fit: contain;
  vertical-align: middle;
}
.goods-goodsOrder {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 20px;
  height: 13px;
  line-height: 13px;
  background: rgba(0, 0, 0, 0.6);
  text-align: center;
  color: #ffffff;
  font-size: 12px;
}
.link-text-mini {
  font-size: 12px;
  &.el-link--primary.is-disabled {
    color: rgba(172, 178, 191, 1);
  }
}
.table-dark {
  margin-top: 10px;
}
.table-dark.el-table::before {
  display: none;
}
.table-dark ::v-deep {
  .el-table__cell {
    padding: 16px 0;
  }
  .el-table__row:last-child td.el-table__cell {
    border-bottom: none;
  }
}
.switch-mini {
  height: 14px;
  line-height: 14px;
  ::v-deep {
    .el-switch__core {
      height: 14px;
    }
    .el-switch__core:after {
      width: 10px;
      height: 10px;
    }
  }
  &.el-switch.is-checked {
    ::v-deep .el-switch__core::after {
      margin-left: -12px;
    }
  }
}
.skelo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.tip-icon {
  width: 11px;
  height: 11px;
  margin-top: -1px;
}
</style>
